import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-intro',
  templateUrl: './page-intro.component.html',
  styleUrl: './page-intro.component.scss'
})
export class PageIntroComponent implements OnInit{
  private router = inject(Router);

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(['/language']); // Replace with your target route
    }, 5000);
  }

}
